import {
  Box
} from '@mui/material';
import BodySwitchTable from './bodyTable';

const BodySwitchManagment = () => {
  return (
    <Box>
      <BodySwitchTable></BodySwitchTable>
    </Box>
  );
};

export default BodySwitchManagment;
